import React, { useEffect, useState } from "react";
import SuperAdminLayout from "../../layout/SuperAdminLayout";
import { Button, Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import AddMerchantDrawer from "./AddMerchantDrawer";

const columns = [
  {
    title: "Business Name",
    dataIndex: "business_name",
    sorter: (a, b) => a.business_name - b.business_name,
  },
  {
    title: "Registered Name",
    dataIndex: "fullname",
    sorter: (a, b) => a.reg_firstname - b.reg_firstname,
  },
  {
    title: "Address",
    dataIndex: "address",
    filters: [
      {
        text: "BUTUAN CITY (Capital)",
        value: "BUTUAN CITY (Capital)",
      },
      {
        text: "CITY OF PANABO",
        value: "CITY OF PANABO",
      },
      {
        text: "CITY OF TAGUM (Capital)",
        value: "CITY OF TAGUM (Capital)",
      },
      {
        text: "DAVAO CITY",
        value: "DAVAO CITY",
      },
    ],
    // onFilter: (value, record) => {
    //     // console.log("RECORD", record.address.indexOf(value) === 0)
    //     // console.log("RECORD", record.address.indexOf(value))
    //     // console.log("VALUE", value)
    //     return (
    //         parseInt(record.address.indexOf(value)) > 0
    //     )
    // },
    // filteredValue: filteredInfo.address || null,
    onFilter: (value, record) => record.address.includes(value),
    sorter: (a, b) => a.address.length - b.address.length,
    // sortOrder: sortedInfo.columnKey === 'address' ? sortedInfo.order : null,
    ellipsis: true,
  },
//   {
//     title: "Action",
//     key: "action",
//     //   sorter: true,
//     render: (_, record) => {
//       return (
//         <span>
//           <Typography.Link
//             onClick={() => console.log("ID", record.id)}
//             style={{
//               marginRight: 8,
//             }}
//           >
//             Edit
//           </Typography.Link>

//           <Typography.Link
//             onClick={() => console.log("ID", record.id)}
//             style={{
//               marginRight: 8,
//             }}
//           >
//             Delete
//           </Typography.Link>
//         </span>
//       );
//     },
//   },
];

// const defaultExpandable = {
//   expandedRowRender: (record) => <p>{record.description}</p>,
// };

const SuperadminMerchants = () => {
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);

  // const expandable = defaultExpandable;
  const tableLayout = "";
  const scroll = {};
  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantList = () => {
    axios
      .get("user/admin/merchant-list")
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getMerchantList();
  }, []);

  return (
    <SuperAdminLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
        >
          Merchant
        </Button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={merchantList.data.length > 0 ? merchantList.data : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddMerchantDrawer 
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantList={() => getMerchantList()}
        />
      )}
    </SuperAdminLayout>
  );
};

export default SuperadminMerchants;
